import axios from '../assets/axios.wrap';
const contextPath = '/remote';
export function getRecordList(data) {
    return axios.postByJson(`${contextPath}/record/list`, data);
}
export function getRecordDetailList(data) {
    return axios.postByJson(`${contextPath}/record/detail/list`, data);
}
// 项目存档-板卡信息查询
export function getArchiveBoard(data) {
    return axios.get(`${contextPath}/archive/board`, { params: data });
}
// 项目存档-系统单元配置
export function getArchiveConfig(data) {
    return axios.get(`${contextPath}/archive/config`, { params: data });
}
// 项目存档-回路板卡查询
export function getArchiveLoopboard(data) {
    return axios.get(`${contextPath}/archive/loopboard`, { params: data });
}
// 项目名臣列表
export function getProductList(data) {
    return axios.get(`${contextPath}/product/list`, { params: data });
}
//项目存档-板卡信息保存
export function saveArchive(data) {
    return axios.postByFormUrl(`${contextPath}/archive/save`, data);
}
